import { render } from "./RelatedItems.vue?vue&type=template&id=4403898e&scoped=true&ts=true"
import script from "./RelatedItems.vue?vue&type=script&lang=ts"
export * from "./RelatedItems.vue?vue&type=script&lang=ts"

import "./RelatedItems.vue?vue&type=style&index=0&id=4403898e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4403898e"]])

export default __exports__